<script lang="ts">
import { ToastNotification } from "carbon-components-svelte";

export let title:string;
export let subtitle:string;
export let kind;
export let onClose;

</script>

<ToastNotification lowContrast title={title} subtitle={subtitle} kind={kind} on:close={onClose} />